import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { Crown, Download, ShieldCheck, Zap } from 'lucide-react';
const MASTER_SYSTEM_CHECKOUT = 'https://43skvt-1y.myshopify.com/products/sistema-completo-de-ventas-en-amazon-fba-fbm-2026';
export function Hero() {
  const beginNow = () => {
    window.open(MASTER_SYSTEM_CHECKOUT, '_blank', 'noopener,noreferrer');
  };
  return <section className="bg-brand-white px-5 pb-24 pt-16 sm:px-6 md:pb-32 md:pt-24" data-id="element-353" data-mp="12a0it4iflorg">
      <div className="mx-auto max-w-6xl" data-id="element-354" data-mp="xanpc0x21jfw">
        <div className="grid items-center gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-355" data-mp="xbp8yts4ze98">
          <div className="order-2 text-center lg:order-1 lg:text-left" data-id="element-356" data-mp="sa9n4zi4x3ps">
            <FadeIn data-id="element-357" data-mp="ncq0pcba9kmr">
              <div className="mb-7 inline-flex items-center gap-2 rounded-full border border-brand-gold/40 bg-brand-beige px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] text-brand-green" data-id="element-358" data-mp="nb6mdr96tjnm">
                <Crown className="h-3.5 w-3.5 text-brand-gold" data-id="element-359" data-mp="381e6fqej6u0d" />
                Amazon Master System™
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-360" data-mp="3j6oc9l508oqm">
              <h1 className="font-serif text-4xl font-bold leading-[1.08] tracking-tight text-brand-green sm:text-5xl md:text-6xl" data-id="element-361" data-mp="3o858h3cjnn0v">
                Aprende a vender en Amazon desde cero con un método paso a paso.
              </h1>
            </FadeIn>

            <FadeIn delay={0.18} data-id="element-362" data-mp="3ebisosz2rm5p">
              <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-brand-text/70 sm:text-lg lg:mx-0" data-id="element-363" data-mp="30iawsp3yo4i7">
                Un programa completo que reúne todo lo que necesitas para
                comenzar en Amazon FBA y FBM desde cero, incluso si nunca has
                vendido por internet.
              </p>
            </FadeIn>

            <FadeIn delay={0.26} data-id="element-364" data-mp="2vjg5eyrxh7mh">
              <div className="mx-auto mt-9 max-w-md lg:mx-0" data-id="element-365" data-mp="2hj5exwuj5v1u">
                <Button onClick={beginNow} aria-label="Comenzar ahora" className="w-full" data-id="element-366" data-mp="2hjowhcg9qhfc">
                  COMENZAR AHORA
                </Button>

                <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-brand-text/55 lg:justify-start" data-id="element-367" data-mp="s44ifoom7nif">
                  <span className="flex items-center gap-1.5" data-id="element-368" data-mp="id9vei3jojvx">
                    <Zap className="h-3.5 w-3.5 text-brand-green" data-id="element-369" data-mp="dd5ews2mzp5p" />
                    Acceso inmediato
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-370" data-mp="1b15prg5n5zpj">
                    <Download className="h-3.5 w-3.5 text-brand-green" data-id="element-371" data-mp="161t24t6y4olw" />
                    Descarga digital
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-372" data-mp="111ybmqr3211d">
                    <ShieldCheck className="h-3.5 w-3.5 text-brand-green" data-id="element-373" data-mp="x14ow0pdmsa2" />
                    Compra segura
                  </span>
                </div>
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.12} data-id="element-374" data-mp="3hrlmgnykwhbm">
            <div className="order-1 mx-auto w-full max-w-2xl lg:order-2" data-id="element-375" data-mp="3hqagqilkozhv">
              <img src="https://cdn.magicpatterns.com/uploads/tioDqWBANZPtQH21RpwvZP/sistema_completo.png" alt="Sistema Completo Amazon FBA + FBM" className="h-auto w-full rounded-2xl object-contain shadow-[0_30px_80px_-24px_rgba(26,26,26,0.28)]" data-id="element-376" data-mp="1x9umefegzlpj" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}